// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { type JiraCommonFlagProps, JiraCommonFlag } from './jira-flag';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { commonFlagTestId, default } from './common-flag';
